import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const G  = '#2E7D32';
const G1 = '#E8F5E9';
const G2 = '#C8E6C9';
const uid = () => '_' + Math.random().toString(36).slice(2);

// ── Reusable image uploader ──────────────────────────────────
function ImageUploader({ value, onChange, size = 64, label = 'Upload Image' }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return toast.error('Only image files allowed');
    if (file.size > 2 * 1024 * 1024) return toast.error('Image must be under 2MB');

    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('files', file);
      const { data } = await api.post('/upload/media', fd);
      onChange(data.files[0].url);
      toast.success('Image uploaded ✅');
    } catch (err) {
      toast.error('Upload failed: ' + (err.response?.data?.message || err.message));
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
      <div style={{
        width: size, height: size, borderRadius:10, border:'2px dashed #dee2e6',
        overflow:'hidden', background:'#f8f9fa', display:'flex',
        alignItems:'center', justifyContent:'center', flexShrink:0,
      }}>
        {value
          ? <img src={value} alt="preview" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
          : <span style={{ fontSize:22, color:'#adb5bd' }}>🖼️</span>
        }
      </div>

      <div style={{ flex:1 }}>
        <label style={{
          display:'inline-flex', alignItems:'center', gap:6,
          padding:'7px 14px', background:G, color:'white',
          borderRadius:8, fontSize:12, fontWeight:600, cursor:'pointer',
          opacity: uploading ? 0.7 : 1,
        }}>
          {uploading ? 'Uploading...' : <><span>📤</span> {label}</>}
          <input type="file" accept="image/*" style={{ display:'none' }} onChange={handleFile} disabled={uploading} />
        </label>
        {value && (
          <button onClick={() => onChange('')}
            style={{ marginLeft:8, fontSize:11, color:'#DC2626', background:'none', border:'none', cursor:'pointer' }}>
            ✕ Remove
          </button>
        )}
        <div style={{ fontSize:11, color:'#6C757D', marginTop:3 }}>JPG, PNG, WebP · max 2MB</div>
      </div>
    </div>
  );
}

export default function AddNurseryCategories() {
  const [categories,  setCategories]  = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [saving,      setSaving]      = useState(false);
  const [selCat,      setSelCat]      = useState(null);
  const [searchCat,   setSearchCat]   = useState('');
  const [searchSub,   setSearchSub]   = useState('');
  const [showAddCat,  setShowAddCat]  = useState(false);
  const [showAddSub,  setShowAddSub]  = useState(false);
  const [editCat,     setEditCat]     = useState(null);
  const [editSub,     setEditSub]     = useState(null);
  const [newCat,      setNewCat]      = useState({ name:'', image:'' });
  const [newSub,      setNewSub]      = useState({ name:'', image:'' });
  const [catDragIdx,  setCatDragIdx]  = useState(null);
  const [catDragOver, setCatDragOver] = useState(null);
  const [subDragIdx,  setSubDragIdx]  = useState(null);
  const [subDragOver, setSubDragOver] = useState(null);
  const [selected, setSelected] = useState(null);

 useEffect(() => { load(); }, []);

  const load = async () => {
  setLoading(true);
  try {
    const { data } = await api.get('/nursery-categories');

    const cats = (data.categories || []).map(c => ({
      ...c,
      label: c.label || c.name || c.key,
      subCategories: c.subCategories || [],
      isActive: c.isActive !== false,
    }));

    setCategories(cats);

    

  }  finally {
    setLoading(false);
  }
};

// add category //
  const addCategory = async () => {
  if (!newCat.name.trim()) {
    return toast.error("Category name required");
  }

  setSaving(true);

  try {
    const { data } = await api.post("/nursery-categories", {
      key: newCat.name.toLowerCase().replace(/\s+/g, "_"),
      label: newCat.name,
      image: newCat.image || ""
    });

    setCategories(prev => [...prev, data.category]);

    toast.success("Category Added");

    setNewCat({
      name: "",
      image: ""
    });

    setShowAddCat(false);

  } catch (err) {
    toast.error(err.response?.data?.message || "");
  } finally {
    setSaving(false);
  }
};
// updatecategory//
  const updateCategory = async () => {
  if (!editCat?.label?.trim()) {
    return toast.error("Category name is required");
  }

  setSaving(true);

  try {
    const { data } = await api.put(
      `/nursery-categories/${editCat._id}`,
      {
        label: editCat.label,
        emoji: editCat.emoji,
        image: editCat.image || "",
        isActive: editCat.isActive,
      }
    );

    setCategories(prev =>
      prev.map(cat =>
        cat._id === editCat._id ? data.category : cat
      )
    );

    if (selected?._id === editCat._id) {
      setSelected(data.category);
    }

    toast.success("Category updated successfully ✅");
    setEditCat(null);

  } catch (err) {
    toast.error(err.response?.data?.message || "Update failed");
  } finally {
    setSaving(false);
  }
};

// togglecategory //
  const toggleCategory = async (cat) => {
  try {
    const { data } = await api.put(
      `/nursery-categories/${cat._id}`,
      {
        isActive: !cat.isActive,
      }
    );

    setCategories(prev =>
      prev.map(c =>
        c._id === cat._id ? data.category : c
      )
    );

    if (selected?._id === cat._id) {
      setSelected(data.category);
    }

    toast.success(
      data.category.isActive
        ? "Category Enabled ✅"
        : "Category Disabled"
    );

  } catch (err) {
    toast.error(err.response?.data?.message || "Unable to update");
  }
};

// deletecategory //
  const deleteCategory = async (cat) => {
  if (
    !window.confirm(
      `Delete "${cat.label}" and all its subcategories?`
    )
  ) {
    return;
  }

  try {
    await api.delete(`/nursery-categories/${cat._id}`);

    const updated = categories.filter(
      c => c._id !== cat._id
    );

    setCategories(updated);

    if (selected?._id === cat._id) {
      setSelected(updated.length ? updated[0] : null);
    }

    toast.success("Category deleted successfully ✅");

  } catch (err) {
    toast.error(err.response?.data?.message || "Delete failed");
  }
};

  const saveCatOrder = async (cats) => {
    setCategories(cats);
    if (selCat) setSelCat(cats.find(c => c._id === selCat._id) || null);
    try {
      await Promise.all(cats.map((c, i) => api.put('/nursery-categories/' + c._id, { order: i })));
    } catch {}
  };

  //  addsubcategory 
  const addSubCategory = async () => {
    if (!newSub.name.trim() || !selCat) return toast.error('Name required');
    setSaving(true);
    try {
      await api.post('/nursery-categories/' + selCat._id + '/subcategories', {
        name: newSub.name, image: newSub.image || '',
      });
      toast.success('Sub-category added ✅');
      setShowAddSub(false);
      setNewSub({ name:'', image:'' });
      loadCategories();
    } catch (err) {
     
    } finally { setSaving(false); }
  };

  // const updateSubCategory = async () => {
  //   if (!editSub?.name?.trim()) return toast.error('Name required');
  //   setSaving(true);
  //   try {
  //     await api.put('/nursery-categories/' + selCat._id + '/subcategories/' + editSub._id, {
  //       name: editSub.name, image: editSub.image || '',
  //     });
  //     toast.success('Updated ✅');
  //     setEditSub(null);
  //     loadCategories();
  //   } catch (err) {
  //     toast.error(err.response?.data?.message || 'Error updating');
  //   } finally { setSaving(false); }
  // };


 const updateSubCategory = async () => {
  if (!editSub?.name?.trim()) {
    return toast.error("Sub-category name required");
  }

  setSaving(true);

  try {
    const { data } = await api.put(
      `/nursery-categories/${selCat._id}/subcategories/${editSub._id}`,
      {
        name: editSub.name,
        emoji: editSub.emoji || "",
        image: editSub.image || ""
      }
    );

    setCategories(prev =>
      prev.map(cat =>
        cat._id === selCat._id ? data.category : cat
      )
    );

    setSelCat(data.category);
    setEditSub(null);

    toast.success("Sub-category updated successfully ✅");

  } catch (err) {
    toast.error(err.response?.data?.message || "Update failed");
  } finally {
    setSaving(false);
  }
};

const deleteSubCategory = async (sub) => {
  if (!window.confirm(`Delete "${sub.name}"?`)) return;

  try {
    await api.delete(
      `/nursery-categories/${selCat._id}/subcategories/${sub._id}`
    );

    toast.success("Deleted successfully");

    const { data } = await api.get("/nursery-categories");

    setCategories(data.categories);

    const updated = data.categories.find(c => c._id === selCat._id);
    setSelCat(updated || null);

  } catch (err) {
    toast.error(err.response?.data?.message || "Delete failed");
  }
};

  const saveSubOrder = async (subs) => {
    const upd = { ...selCat, subCategories: subs };
    setSelCat(upd);
    setCategories(p => p.map(c => c._id === selCat._id ? upd : c));
    try {
      await api.put('/nursery-categories/' + selCat._id, { subCategories: subs });
    } catch {}
  };

  const totalSubs     = categories.reduce((s, c) => s + (c.subCategories?.length || 0), 0);
  const totalActive   = categories.filter(c => c.isActive !== false).length;
  const totalDisabled = categories.filter(c => c.isActive === false).length;
  const filteredCats  = categories.filter(c => (c.label || '').toLowerCase().includes(searchCat.toLowerCase()));
  const filteredSubs  = (selCat?.subCategories || []).filter(s => s.name.toLowerCase().includes(searchSub.toLowerCase()));

  // ── MODAL ─────────────────────────────────────────────────────
  const Modal = ({ title, onClose, children, footer }) => (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal__header">
          <div className="modal__title">{title}</div>
          <button className="modal__close" onClick={onClose}>×</button>
        </div>
        <div className="modal__body">{children}</div>
        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>
  );

  return (
    <AdminLayout title="🗂️ Nursery Category Manager">

      {/* ── STAT CARDS ──────────────────────────────────────────── */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 }}>
        {[
          { label:'Total Categories', value:categories.length, border:G },
          { label:'Sub-categories',   value:totalSubs,         border:'#1565C0' },
          { label:'Active',           value:totalActive,       border:'#E65100' },
          { label:'Disabled',         value:totalDisabled,     border:'#C62828' },
        ].map(s => (
          <div key={s.label} className="stat-card" style={{ borderLeft:'4px solid '+s.border }}>
            <div className="stat-card__label">{s.label}</div>
            <div className="stat-card__value" style={{ fontSize:26 }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* ── MAIN LAYOUT ──────────────────────────────────────────── */}
      <div style={{ display:'grid', gridTemplateColumns:'280px 1fr', gap:16 }}>

        {/* LEFT — Category List */}
        <div>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
            <span style={{ fontWeight:700, fontSize:14, color:G }}>Categories</span>
            <button className="btn btn--primary btn--sm" onClick={() => setShowAddCat(true)}>+ Add</button>
          </div>
          <input value={searchCat} onChange={e => setSearchCat(e.target.value)}
            placeholder="Search categories..."
            style={{ width:'100%', padding:'8px 12px', border:'1px solid #E0E0E0', borderRadius:8, fontSize:12, outline:'none', marginBottom:10, boxSizing:'border-box' }} />

          {loading ? (
            <div style={{ textAlign:'center', padding:30, color:'#9E9E9E' }}>Loading...</div>
          ) : filteredCats.length === 0 ? (
            <div style={{ textAlign:'center', padding:30, color:'#9E9E9E' }}>
              <div style={{ fontSize:32, marginBottom:8 }}>🗂️</div>
              <div>No categories yet</div>
              <button className="btn btn--primary btn--sm" style={{ marginTop:10 }} onClick={() => setShowAddCat(true)}>Add first</button>
            </div>
          ) : (
            filteredCats.map((cat, idx) => {
              const isAct    = selCat?._id === cat._id;
              const isDrg    = catDragIdx  === idx;
              const isDrgOv  = catDragOver === idx;
              return (
                <div key={cat._id} draggable
                  onDragStart={e => { e.dataTransfer.effectAllowed='move'; setCatDragIdx(idx); }}
                  onDragOver={e  => { e.preventDefault(); if (catDragOver!==idx) setCatDragOver(idx); }}
                  onDragLeave={()  => setCatDragOver(null)}
                  onDrop={e => { e.preventDefault(); if (catDragIdx===null||catDragIdx===idx) return; const r=[...filteredCats]; const[m]=r.splice(catDragIdx,1); r.splice(idx,0,m); setCatDragIdx(null); setCatDragOver(null); saveCatOrder(r); }}
                  onDragEnd={() => { setCatDragIdx(null); setCatDragOver(null); }}
                  onClick={() => setSelCat(cat)}
                  style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 12px', borderRadius:10, cursor:'grab', marginBottom:6, border:'1.5px solid '+(isDrgOv?G:isAct?G:'#E8F5E9'), background:isDrg?'#f5f5f5':isDrgOv?G1:isAct?G1:'white', opacity:isDrg?.4:cat.isActive===false?.5:1, transition:'all .15s' }}>
                  <span style={{ color:'#ccc', fontSize:13 }}>⠿</span>
                  <div style={{ width:36, height:36, borderRadius:9, background:G1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, flexShrink:0, border:'1px solid '+G2, overflow:'hidden' }}>
                    {cat.image
                      ? <img src={cat.image} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} onError={e => e.target.style.display='none'} />
                      : (cat.emoji || '')}
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:13, fontWeight:700, color:'#1B5E20', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{cat.label || cat.name}</div>
                    <div style={{ fontSize:11, color:'#9E9E9E' }}>{cat.subCategories?.length || 0} items</div>
                  </div>
                  {cat.isActive===false && <span className="badge badge--danger" style={{ fontSize:9 }}>OFF</span>}
                </div>
              );
            })
          )}
        </div>

        {/* RIGHT — Subcategory Panel */}
        {selCat ? (
          <div>
            {/* Category header */}
            <div style={{ background:'white', borderRadius:12, padding:'14px 16px', marginBottom:14, border:'1px solid #E8F5E9', display:'flex', alignItems:'center', justifyContent:'space-between', boxShadow:'0 1px 4px rgba(0,0,0,.06)' }}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ width:44, height:44, borderRadius:11, background:G1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, border:'1px solid '+G2, overflow:'hidden' }}>
                  {selCat.image
                    ? <img src={selCat.image} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} onError={e => e.target.style.display='none'} />
                    : (selCat.emoji || '')}
                </div>
                <div>
                  <div style={{ fontSize:16, fontWeight:800, color:G }}>{selCat.label || selCat.name}</div>
                  <div style={{ fontSize:12, color:'#9E9E9E' }}>{selCat.subCategories?.length || 0} sub-categories</div>
                </div>
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <button className="btn btn--outline btn--sm" onClick={() => setEditCat({...selCat})}>✏️ Edit</button>
                <button className={'btn btn--sm ' + (selCat.isActive===false ? 'btn--success' : 'btn--warning')} onClick={() => toggleCategory(selCat)}>
                  {selCat.isActive===false ? '✅ Enable' : '— Disable'}
                </button>
                <button className="btn btn--danger btn--sm" onClick={() => deleteCategory(selCat)}>🗑 Delete</button>
              </div>
            </div>

            {/* Subcategory list */}
            <div style={{ background:'white', borderRadius:12, padding:'14px 16px', border:'1px solid #E8F5E9', boxShadow:'0 1px 4px rgba(0,0,0,.06)' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
                <span style={{ fontWeight:700, fontSize:14, color:G }}>🏷️ Sub-categories</span>
                <button className="btn btn--primary btn--sm" onClick={() => setShowAddSub(true)}>+ Add Sub</button>
              </div>
              <input value={searchSub} onChange={e => setSearchSub(e.target.value)}
                placeholder="Search sub-categories..."
                style={{ width:'100%', padding:'8px 12px', border:'1px solid #E0E0E0', borderRadius:8, fontSize:12, outline:'none', marginBottom:12, boxSizing:'border-box' }} />

              {filteredSubs.length === 0 ? (
                <div style={{ textAlign:'center', padding:'30px 0', color:'#9E9E9E' }}>
                  <div style={{ fontSize:32, marginBottom:8 }}></div>
                  <div style={{ fontSize:13 }}>No sub-categories yet</div>
                  <button className="btn btn--primary btn--sm" style={{ marginTop:10 }} onClick={() => setShowAddSub(true)}>Add first</button>
                </div>
              ) : (
                <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10 }}>
                  {filteredSubs.map((sub, idx) => {
                    const isDrg   = subDragIdx  === idx;
                    const isDrgOv = subDragOver === idx;
                    const realIdx = (selCat?.subCategories || []).findIndex(s => s._id === sub._id);
                    return (
                      <div key={sub._id} draggable
                        onDragStart={e => { e.dataTransfer.effectAllowed='move'; setSubDragIdx(idx); }}
                        onDragOver={e  => { e.preventDefault(); if (subDragOver!==idx) setSubDragOver(idx); }}
                        onDragLeave={() => setSubDragOver(null)}
                        onDrop={e => { e.preventDefault(); if (subDragIdx===null||subDragIdx===idx) return; const s=[...filteredSubs]; const[m]=s.splice(subDragIdx,1); s.splice(idx,0,m); setSubDragIdx(null); setSubDragOver(null); saveSubOrder(s); }}
                        onDragEnd={() => { setSubDragIdx(null); setSubDragOver(null); }}
                        style={{ borderRadius:10, border:'1.5px solid '+(isDrgOv?G:'#E8F5E9'), background:isDrg?'#f5f5f5':isDrgOv?G1:'#FAFFF8', overflow:'hidden', cursor:'grab', transition:'all .15s', opacity:isDrg?.4:1 }}>
                        {/* Image */}
                        <div style={{ height:80, background:G1, overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', position:'relative' }}>
                          {sub.image
                            ? <img src={sub.image} alt={sub.name} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                            : <span style={{ fontSize:28, opacity:.4 }}></span>}
                          <span style={{ position:'absolute', top:5, left:6, fontSize:11, color:'rgba(255,255,255,.8)', background:'rgba(0,0,0,.2)', borderRadius:3, padding:'1px 5px' }}>⠿</span>
                        </div>
                        {/* Name */}
                        <div style={{ padding:'7px 8px', textAlign:'center', fontSize:12, fontWeight:700, color:'#1B5E20', borderBottom:'1px solid #F1F8E9' }}>
                          {sub.name}
                        </div>
                        {/* Order buttons */}
                        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', borderBottom:'1px solid #F1F8E9' }}>
                          <button onClick={() => { if(realIdx<=0)return; const s=[...(selCat.subCategories||[])]; [s[realIdx-1],s[realIdx]]=[s[realIdx],s[realIdx-1]]; saveSubOrder(s); }}
                            style={{ padding:'5px', background:'none', border:'none', borderRight:'1px solid #F1F8E9', cursor:'pointer', color:'#9E9E9E', fontSize:14 }}>↑</button>
                          <button onClick={() => { const s=[...(selCat.subCategories||[])]; if(realIdx>=s.length-1)return; [s[realIdx],s[realIdx+1]]=[s[realIdx+1],s[realIdx]]; saveSubOrder(s); }}
                            style={{ padding:'5px', background:'none', border:'none', cursor:'pointer', color:'#9E9E9E', fontSize:14 }}>↓</button>
                        </div>
                        {/* Actions */}
                        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr' }}>
                          <button onClick={() => setEditSub({...sub})}
                            style={{ padding:'6px', background:'none', border:'none', borderRight:'1px solid #F1F8E9', cursor:'pointer', color:'#E65100', fontSize:14 }}>✏️</button>
                          <button onClick={() => deleteSubCategory(sub)}
                            style={{ padding:'6px', background:'none', border:'none', cursor:'pointer', color:'#C62828', fontSize:14 }}>🗑</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div style={{ display:'flex', alignItems:'center', justifyContent:'center', background:'white', borderRadius:12, border:'1px solid #E8F5E9', minHeight:300 }}>
            <div style={{ textAlign:'center', color:'#9E9E9E' }}>
              <div style={{ fontSize:48, marginBottom:10 }}>🗂️</div>
              <div style={{ fontSize:14 }}>Select a category to manage sub-categories</div>
            </div>
          </div>
        )}
      </div>

      {/* ══ MODALS ════════════════════════════════════════════════ */}

      {/* Add Category */}
      {showAddCat && (
        <Modal title="➕ Add Category" onClose={() => setShowAddCat(false)}
          footer={<>
            <button className="btn btn--outline" onClick={() => setShowAddCat(false)}>Cancel</button>
            <button className="btn btn--primary" onClick={addCategory} disabled={saving}>{saving ? 'Adding...' : '✅ Add Category'}</button>
          </>}>
          <div className="form-group">
            <label className="label">Category Name *</label>
            <input className="input" autoFocus value={newCat.name}
              onChange={e => setNewCat(p => ({...p, name: e.target.value}))}
              placeholder="e.g. Flowers"
              onKeyDown={e => e.key==='Enter' && addCategory()} />
          </div>
          <div className="form-group">
            <label className="label">Category Image</label>
            <ImageUploader
              value={newCat.image}
              onChange={url => setNewCat(p => ({...p, image: url}))}
              size={64}
            />
          </div>
          <div style={{ padding:'10px 14px', background:G1, borderRadius:8, fontSize:13, display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ width:32, height:32, borderRadius:8, overflow:'hidden', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', background:'white' }}>
              {newCat.image ? <img src={newCat.image} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} /> : null}
            </div>
            <span style={{ fontWeight:600, color:G }}>{newCat.name || 'Category preview'}</span>
          </div>
        </Modal>
      )}

      {/* Edit Category */}
      {editCat && (
        <Modal title="✏️ Edit Category" onClose={() => setEditCat(null)}
          footer={<>
            <button className="btn btn--outline" onClick={() => setEditCat(null)}>Cancel</button>
            <button className="btn btn--primary" onClick={updateCategory} disabled={saving}>{saving ? 'Saving...' : '✅ Save Changes'}</button>
          </>}>
          <div className="form-group">
            <label className="label">Category Name *</label>
            <input className="input" autoFocus value={editCat.label || ''}
              onChange={e => setEditCat(p => ({...p, label: e.target.value}))} />
          </div>
          <div className="form-group">
            <label className="label">Category Image</label>
            <ImageUploader
              value={editCat.image || ''}
              onChange={url => setEditCat(p => ({...p, image: url}))}
              size={64}
            />
          </div>
        </Modal>
      )}

      {/* Add Sub-category */}
      {showAddSub && selCat && (
        <Modal title="➕ Add Sub-category" onClose={() => setShowAddSub(false)}
          footer={<>
            <button className="btn btn--outline" onClick={() => setShowAddSub(false)}>Cancel</button>
            <button className="btn btn--primary" onClick={addSubCategory} disabled={saving}>{saving ? 'Adding...' : '✅ Add'}</button>
          </>}>
          <div style={{ fontSize:12, color:'#9E9E9E', marginBottom:12 }}>
            Under: <strong style={{ color:G }}>{selCat.emoji} {selCat.label || selCat.name}</strong>
          </div>
          <div className="form-group">
            <label className="label">Sub-category Name *</label>
            <input className="input" autoFocus value={newSub.name}
              onChange={e => setNewSub(p => ({...p, name: e.target.value}))}
              placeholder="e.g. Tomato"
              onKeyDown={e => e.key==='Enter' && addSubCategory()} />
          </div>
          <div className="form-group">
            <label className="label">Image URL (optional)</label>
            <input className="input" value={newSub.image}
              onChange={e => setNewSub(p => ({...p, image: e.target.value}))}
              placeholder="https://..." />
          </div>
        </Modal>
      )}

      {/* Edit Sub-category */}
      {editSub && selCat && (
        <Modal title="✏️ Edit Sub-category" onClose={() => setEditSub(null)}
          footer={<>
            <button className="btn btn--outline" onClick={() => setEditSub(null)}>Cancel</button>
            <button className="btn btn--primary" onClick={updateSubCategory} disabled={saving}>{saving ? 'Saving...' : '✅ Save'}</button>
          </>}>
          <div className="form-group">
            <label className="label">Name *</label>
            <input className="input" autoFocus value={editSub.name || ''}
              onChange={e => setEditSub(p => ({...p, name: e.target.value}))} />
          </div>
          <div className="form-group">
            <label className="label">Image URL</label>
            <input className="input" value={editSub.image || ''}
              onChange={e => setEditSub(p => ({...p, image: e.target.value}))}
              placeholder="https://..." />
            {editSub.image && <img src={editSub.image} alt="" style={{ width:60, height:60, objectFit:'cover', borderRadius:8, marginTop:8, border:'1px solid '+G2 }} />}
          </div>
        </Modal>
      )}

    </AdminLayout>
  );
}